import { useUX } from '@/ux'

export function ThemeToggle() {
  const { theme, setTheme } = useUX()

  // Get effective theme for display (system becomes light or dark)
  const effectiveTheme =
    theme === 'system'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
      : theme

  const themes: { value: 'light' | 'dark'; label: string; icon: string }[] = [
    { value: 'light', label: 'Light', icon: '☀️' },
    { value: 'dark', label: 'Dark', icon: '🌙' },
  ]

  return (
    <div
      className="flex gap-1 bg-gray-100 dark:bg-gray-800 rounded-lg p-1"
      role="group"
      aria-label="Theme switcher"
    >
      {themes.map(({ value, label, icon }) => (
        <button
          key={value}
          type="button"
          onClick={() => setTheme(value)}
          className={`px-2 py-1 text-sm rounded transition ${
            effectiveTheme === value
              ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100'
          }`}
          aria-label={`Switch to ${label} theme`}
          aria-pressed={effectiveTheme === value}
          title={`${label} mode`}
        >
          <span className="text-base" aria-hidden="true">
            {icon}
          </span>
          <span className="sr-only">{label}</span>
        </button>
      ))}
    </div>
  )
}
